<template>
    <div>
        <el-container class="toolBar">
            <el-main style="overflow-y: hidden;padding-bottom: 10px">
                <div >
                    <el-form :inline="true" style="text-align: left;padding-left:10px;" label-width="100px">
                        <div>
                            <el-form-item label="仓号">
                                <el-input style="width: 180px" v-model="warehouseNo" placeholder="双击选择仓号" @click.native="selWareHouse" >
                                </el-input>
                            </el-form-item>
                            <el-form-item label="物资编码">
                                <el-input style="width: 180px" v-model="proCode" placeholder="请输入物资编码"></el-input>
                            </el-form-item>
                            <el-form-item label="账单日期">
                                <el-date-picker
                                        v-model="billDate"
                                        size="medium"
                                        type="daterange"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item>
                                <el-button icon="el-icon-search" type="primary" size="medium" @click="search">
                                    查询
                                </el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-button icon="el-icon-download" type="primary" size="medium" @click="excel">
                                    导出
                                </el-button>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="Xdriver"></div>
            </el-main>
        </el-container>
        <selWareHouse v-if="showWareHouse"
                      :warehouseId="warehouseId"
                      @closeDialog="closeDialog"
                      @checkRow="checkWareHouse">
        </selWareHouse>
    </div>
</template>

<script>
    import selWareHouse from '@/components/page/stock/warehouse/selWareHouse'

    export default {
        name: 'toolBar',
        props: ['menuId', 'toolHeight', 'loading'],
        components: {
            selWareHouse
        },
        data() {
            return {
                searBarHeight: 70,

                warehouseId:"",
                warehouseNo:"",
                proCode:"",
                billDate:[],
                showWareHouse:false,
            }
        },
        methods: {
            closeDialog() {
                this.showWareHouse = false;
            },
            selWareHouse(){
                this.showWareHouse = true;
            },
            checkWareHouse(row) {
                this.warehouseId = row.warehouseId;
                this.warehouseNo = row.warehouseNo;
                this.showWareHouse = false;
            },
            search() {

                let startDate = "";
                let endDate = "";
                if(this.billDate && this.billDate.length>0){
                    startDate = this.billDate[0];
                    endDate = this.billDate[1];
                }


                let searchData = {
                    warehouseNo:this.warehouseNo,
                    proCode:this.proCode,
                    startDate:startDate,
                    endDate:endDate
                }
                this.$emit('search',searchData);
            },
            excel() {
                let startDate = "";
                let endDate = "";
                if(this.billDate && this.billDate.length>0){
                    startDate = this.billDate[0];
                    endDate = this.billDate[1];
                }
                let searchData = {
                    warehouseNo:this.warehouseNo,
                    proCode:this.proCode,
                    startDate:startDate,
                    endDate:endDate
                }
                this.$emit('excel',searchData);
            }
        }
    }
</script>

